export const config = {
    appUrl: process.env.REACT_APP_MOBILITY_APP_URL || `https://ciklopark.academica.dev/app`,
    apiUrl: process.env.REACT_APP_MOBILITY_API_URL || `https://ciklopark.academica.dev/api`,
    url: process.env.REACT_APP_MOBILITY_URL || `https://ciklopark.academica.dev/`,
    geoserverUrl: process.env.REACT_APP_GEOSERVER_URL || 'https://ciklopark.academica.dev/geoserver',
}